import React from 'react';
import { Building, Layers, Shield } from 'lucide-react';
import { featuresData } from '../mock';

const iconMap = {
  Building: Building,
  Layers: Layers,
  Shield: Shield
};

const Features = () => {
  return (
    <section id="features" className="dark-full-container" style={{ paddingTop: '160px', paddingBottom: '160px', backgroundColor: 'var(--bg-secondary)' }}>
      <div className="dark-content-container">
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '100px' }}>
          <h2 className="display-large" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
            {featuresData.title}
          </h2>
          <p className="body-large" style={{ maxWidth: '800px', margin: '0 auto' }}>
            {featuresData.subtitle}
          </p>
        </div>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '40px',
          maxWidth: '1400px',
          margin: '0 auto'
        }}>
          {featuresData.pillars.map((pillar, index) => {
            const IconComponent = iconMap[pillar.icon];
            return (
              <div 
                key={index}
                className="ui-card reveal"
                style={{
                  background: 'var(--bg-primary)',
                  border: '1px solid var(--border-subtle)',
                  padding: '50px',
                  transitionDelay: `${Math.min(index, 4) * 0.1}s`
                }}
              >
                <IconComponent 
                  size={48} 
                  color="var(--brand-primary)" 
                  className="icon-badge"
                  style={{ marginBottom: '24px' }}
                />
                <h3 className="heading-1" style={{ marginBottom: '8px' }}>
                  {pillar.title}
                </h3>
                <p className="body-medium" style={{ 
                  color: 'var(--brand-primary)', 
                  marginBottom: '20px',
                  fontWeight: 500
                }}>
                  {pillar.subtitle}
                </p>
                <p className="body-medium" style={{ marginBottom: '32px', lineHeight: 1.6 }}>
                  {pillar.description}
                </p>
                
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {pillar.features.map((feature, featureIndex) => (
                    <li 
                      key={featureIndex} 
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        marginBottom: '12px',
                        fontSize: '16px',
                        color: 'var(--text-secondary)',
                        lineHeight: 1.5
                      }}
                    >
                      <div style={{
                        width: '6px',
                        height: '6px',
                        backgroundColor: 'var(--brand-primary)',
                        borderRadius: '50%',
                        marginTop: '8px',
                        flexShrink: 0
                      }} />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;